import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import { apiRequest } from "../services/api";

function AdminOrdersPage() {
  const [orders, setOrders] = useState([]);
  const [searchOrder, setSearchOrder] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const fetchOrders = useCallback(async () => {
    try {
      const data = await apiRequest("/orders", { auth: true });
      setOrders(data);
    } catch (err) {
      if (err.status === 401 || err.status === 403) {
        navigate("/admin/login");
        return;
      }
      console.error("Failed to fetch orders:", err);
    }
  }, [navigate]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  async function handleStatusChange(orderId, newStatus) {
    try {
      const data = await apiRequest(`/orders/${orderId}/status`, {
        method: "PUT",
        auth: true,
        body: { status: newStatus },
      });
      setMessage(data.message);
      fetchOrders();
    } catch (err) {
      if (err.status === 401 || err.status === 403) {
        navigate("/admin/login");
        return;
      }
      console.error("Failed to update status:", err);
    }
  }

  const filteredOrders = orders.filter((order) => {
    const searchText = searchOrder.toLowerCase();

    return (
      order.fullName.toLowerCase().includes(searchText) ||
      order.email.toLowerCase().includes(searchText) ||
      order.phone.toLowerCase().includes(searchText)
    );
  });

  return (
    <AdminLayout
      title="Orders Dashboard"
      rightContent={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          <input
            type="text"
            placeholder="Search by name, email or phone"
            value={searchOrder}
            onChange={(e) => setSearchOrder(e.target.value)}
            style={searchInputStyle}
          />

          <span
            style={{
              color: "#6b7280",
              fontSize: "14px",
            }}
          >
            Total Orders: {filteredOrders.length}
          </span>
        </div>
      }
    >
      {message && (
        <p
          style={{
            marginTop: 0,
            marginBottom: "16px",
            color: "#16a34a",
            fontWeight: "bold",
          }}
        >
          {message}
        </p>
      )}

      {filteredOrders.length === 0 ? (
        <div style={cardStyle}>
          <p style={{ color: "#6b7280", margin: 0 }}>No matching orders found.</p>
        </div>
      ) : (
        <div style={cardStyle}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
                <th style={thStyle}>ID</th>
                <th style={thStyle}>Customer</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Phone</th>
                <th style={thStyle}>Address</th>
                <th style={thStyle}>Total</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Items</th>
              </tr>
            </thead>

            <tbody>
              {filteredOrders.map((order) => (
                <tr
                  key={order.id}
                  style={{ borderBottom: "1px solid #f1f5f9" }}
                >
                  <td style={tdStyle}>{order.id}</td>
                  <td style={tdStyle}>{order.fullName}</td>
                  <td style={tdStyle}>{order.email}</td>
                  <td style={tdStyle}>{order.phone}</td>
                  <td style={tdStyle}>{order.address}</td>
                  <td style={tdStyle}>₹{order.totalPrice}</td>
                  <td style={tdStyle}>
                    <select
                      value={order.status || "Pending"}
                      onChange={(e) =>
                        handleStatusChange(order.id, e.target.value)
                      }
                      style={selectStyle}
                    >
                      <option value="Pending">Pending</option>
                      <option value="Processing">Processing</option>
                      <option value="Shipped">Shipped</option>
                      <option value="Delivered">Delivered</option>
                    </select>
                  </td>
                  <td style={tdStyle}>
                    {order.items.map((item, i) => (
                      <div key={i}>
                        {item.name} x {item.quantity}
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

const cardStyle = {
  background: "white",
  borderRadius: "16px",
  padding: "20px",
  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
  overflowX: "auto",
};

const searchInputStyle = {
  width: "280px",
  padding: "10px 14px",
  borderRadius: "8px",
  border: "1px solid #d1d5db",
  outline: "none",
  fontSize: "14px",
};

const selectStyle = {
  padding: "8px 10px",
  borderRadius: "8px",
  border: "1px solid #d1d5db",
  outline: "none",
};

const thStyle = {
  textAlign: "left",
  padding: "12px",
  color: "#374151",
  fontSize: "14px",
};

const tdStyle = {
  padding: "12px",
  color: "#111827",
  fontSize: "14px",
  verticalAlign: "top",
};

export default AdminOrdersPage;